import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useDismissFirstTime } from 'components/forYou/FirstTime/useDismissFirstTime';

import { MobileNotification } from './MobileNotification';
import { Rewards } from './Rewards';
import card_baseball from './assets/card_baseball.png';
import card_football from './assets/card_football.png';
import card_nba from './assets/card_nba.png';
import {
  Background,
  Block,
  BlockTitle,
  Disclaimer,
  Dismiss,
  Header,
  MiddleBlock,
  Row,
  StyledChip,
  Title,
  Wrapper,
} from './ui';

const cardBySport = {
  [Sport.FOOTBALL]: card_football,
  [Sport.BASEBALL]: card_baseball,
  [Sport.NBA]: card_nba,
};

export const FirstTime = () => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const { dismiss, hasDismissed } = useDismissFirstTime();

  const { currentUser } = useCurrentUserContext();
  if (hasDismissed) {
    return null;
  }
  return (
    <Wrapper>
      <Background>
        <Header>
          <div />
          <Title as="h3" color="var(--c-neutral-100)">
            <FormattedMessage
              id="ForYou.FirstTime.title"
              defaultMessage="First time in the market?"
            />
          </Title>
          {currentUser && (
            <Dismiss
              size="small"
              startIcon={
                <FontAwesomeIcon color="var(--c-neutral-100)" icon={faXmark} />
              }
              color="transparent"
              onClick={dismiss}
            >
              <BodyM color="var(--c-neutral-100)" as="span">
                <FormattedMessage
                  id="ForYou.FirstTime.button"
                  defaultMessage="Dismiss"
                />
              </BodyM>
            </Dismiss>
          )}
        </Header>
        <Row>
          <Block gap={1.5} center background={cardBySport[sport]}>
            <Vertical center>
              <StyledChip label="1" />
              <BlockTitle>
                <FormattedMessage
                  id="ForYou.FirstTime.block.title.1"
                  defaultMessage="Collect"
                />
              </BlockTitle>
            </Vertical>
          </Block>
          <MiddleBlock gap={1.5} center>
            <Vertical center>
              <StyledChip label="2" />
              <BlockTitle>
                <FormattedMessage
                  id="ForYou.FirstTime.block.title.2"
                  defaultMessage="Trade & Sell"
                />
              </BlockTitle>
            </Vertical>
            <MobileNotification />
            <Disclaimer>
              <FormattedMessage
                id="ForYou.FirstTime.disclaimer"
                defaultMessage="Displayed price is for illustrative purposes only. Actual price may vary."
              />
            </Disclaimer>
          </MiddleBlock>
          <Block gap={1.5} center>
            <Vertical center>
              <StyledChip label="3" />
              <BlockTitle>
                <FormattedMessage
                  id="ForYou.FirstTime.text"
                  defaultMessage="Play & Win"
                />
              </BlockTitle>
            </Vertical>
            <Rewards />
          </Block>
        </Row>
      </Background>
    </Wrapper>
  );
};
